import React from 'react';

import { Container, Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphMultiTextImage = ({ id, entity }) => {
  const paragraph = entity.toJS();

  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;

  const items = paragraph.field_multiple_text_image_items;

  return (
    <Container id={id} className="Paragraph ParagraphMultiTextImage">
      <div className="row">
        <div className="col-12 col-lg-8">
          {title && <h2 className="ParagraphMultiTextImage__title">{title}</h2>}
          {body && (
            <WysiwygField
              className="ParagraphMultiTextImage__body"
              html={body}
            />
          )}
        </div>
      </div>
      <div className={`ParagraphMultiTextImage__items ${items.length === 3 ? 'three' : 'two'}`}>
        {items.map((item) => {
          let image = item.entity.field_media_item[0];
          image = image?.styles[`${items.length === 3 ? '16_9_medium' : '16_9_medium_large'}`];
          const title = item.entity.field_title[0].value;
          const body = item.entity.field_body[0].processed;
          const link = item.entity.field_link[0];

          return (
            <div className="ParagraphMultiTextImage__item">
              {image && (
                <Image src={image} />
              )}
              <h3>{title}</h3>
              <WysiwygField
                html={body}
              />
              {link && (
                <a className="link" href={link.alias || link.uri} target={link.options.attributes?.target || '_self'}>
                  {link.title}
                  <i className="icon icon-arrow-right icon-variant-2" />
                </a>
              )}
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default ParagraphMultiTextImage;
